//@flow

import React from 'react';
import styled from 'styled-components';
import { HideWhenDepartementHaveAppointment } from 'styles/Home/StyledHome';
import CheckBox from 'components/CheckboxComponent';

const HideComponent = styled(HideWhenDepartementHaveAppointment)``;

const StyledValidatedCheckbox = styled.div`
  height: 34px;
  width: 100%;
  display: inline-fex;
`;

const ContainterBox = styled.div`
  margin-top: 7px;
  margin-right: 5px;
`;

const LabelBox = styled.div`
  margin-left: 3px;
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: 17px;
  text-align: initial;
`;

const LinkStyle = styled.a`
  color: #278c7e;
  cursor: pointer;
  &:hover {
    color: #278c7e;
    text-decoration: underline;
  }
`;

export default function TermAndConditions({
  showTerm,
  statusTerm,
  termsAndCon,
  onInputChange,
  onLegalPrivacy,
  onLegalTAC,
  fontSize = 14
}: any) {
  return (
    <div>
      <HideComponent hide={!statusTerm}>
        <StyledValidatedCheckbox>
          <ContainterBox>
            <CheckBox
              checked={termsAndCon}
              value={termsAndCon}
              onChange={onInputChange}
            />
          </ContainterBox>
          <LabelBox>
            He leido y acepto el
            <LinkStyle onClick={onLegalPrivacy}>
              {' '}
              Aviso de Privacidad{' '}
            </LinkStyle>{' '}
            y
            <LinkStyle onClick={onLegalTAC}> Términos y Condiciones.</LinkStyle>
          </LabelBox>
        </StyledValidatedCheckbox>
      </HideComponent>

      <HideComponent hide={statusTerm}>
        <LabelBox fontSize={fontSize}>
          Al dar clic en continuar, estoy de acuerdo con el
          <LinkStyle onClick={onLegalPrivacy}>
            {' '}
            Aviso de Privacidad{' '}
          </LinkStyle>{' '}
          y<LinkStyle onClick={onLegalTAC}> Términos y Condiciones.</LinkStyle>
        </LabelBox>
      </HideComponent>
    </div>
  );
}
